import { useEffect, useState } from 'react'
import { Link, useOutletContext } from 'react-router-dom'
import { api, type EventRow } from '../api'

export function AdminEventsPage() {
  const { user } = useOutletContext<{ user: { username: string; role: string } }>()
  const [events, setEvents] = useState<EventRow[]>([])
  const [title, setTitle] = useState('')
  const [slug, setSlug] = useState('')
  const [error, setError] = useState<string | null>(null)

  const loadEvents = () => {
    void api.events()
      .then((r) => setEvents(r.events))
      .catch(() => setEvents([]))
  }

  useEffect(() => {
    loadEvents()
  }, [])

  async function createEvent(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    try {
      await api.createEvent(title, slug || undefined)
      setTitle('')
      setSlug('')
      loadEvents()
    } catch (err) {
      setError(err instanceof Error ? err.message : '建立失敗')
    }
  }

  return (
    <div className="stack">
      {user.role === 'super_admin' ? (
        <div className="card stack">
          <h2 style={{ margin: 0 }}>建立活動</h2>
          <form className="stack" onSubmit={createEvent}>
            <label className="stack">
              <span className="muted">標題</span>
              <input className="input" value={title} onChange={(e) => setTitle(e.target.value)} required />
            </label>
            <label className="stack">
              <span className="muted">slug（可留空自動產生）</span>
              <input className="input" value={slug} onChange={(e) => setSlug(e.target.value)} placeholder="例如：macau-locals-2026-04" />
            </label>
            {error ? <div style={{ color: '#fecaca' }}>{error}</div> : null}
            <button className="btn primary" type="submit">
              建立
            </button>
          </form>
        </div>
      ) : (
        <div className="card stack">
          <h2 style={{ margin: 0 }}>活動建立權限</h2>
          <div className="muted font-sm">
            目前帳號權限為 <strong>{user.role}</strong>。
            <br />
            只有 super admin 可以建立新活動。請管理員在建立活動後指派你為該活動的管理者。
          </div>
        </div>
      )}

      <div className="card stack">
        <h2 style={{ margin: 0 }}>我的活動列表</h2>
        <div className="stack">
          {events.length === 0 ? <div className="muted">暫未有活動</div> : null}
          {events.map((ev) => (
            <div key={ev.id} className="row" style={{ justifyContent: 'space-between' }}>
              <div>
                <div style={{ fontWeight: 650 }}>🏆 {ev.title}</div>
                <div className="muted">
                  slug：<code>{ev.slug}</code>
                </div>
              </div>
              <Link className="btn primary" to={`/admin/events/${ev.id}`}>
                管理
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
